"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Carousel.css");
var icons = require("./../../../styles/att-icons.css");
var CardHeader_1 = require("../../atoms/CardHeader/CardHeader");
var EnEsLanguageKey_1 = require("../../../utils/EnEsLanguageKey");
var key_press_1 = require("../../../utils/key-press");
var tabIsPressed = key_press_1.KeyPress.tabIsPressed;
var shiftIsPressed = key_press_1.KeyPress.shiftIsPressed;
var Carousel = /** @class */ (function (_super) {
    __extends(Carousel, _super);
    function Carousel(props) {
        var _this = _super.call(this, props) || this;
        _this.carouselClipper = ' ';
        _this.carouselContainer = ' ';
        _this.carouselDiv = ' ';
        _this.carouselNav = ' ';
        _this.carouselPadded = ' ';
        _this.nextButton = ' ';
        _this.prevButton = ' ';
        _this.testIdFirst = '';
        _this.testIdSecond = '';
        _this.counter = 0;
        _this.updateParameters = function () {
            if (!_this.carouselEl) {
                return;
            }
            var visibleArea = _this.carouselEl.parentElement.offsetWidth;
            var cardsContainer = _this.carouselEl.children[0];
            var cardEl = cardsContainer.children[0];
            var cardWidth = _this.getCardWidth(cardEl);
            var lastCardMargin = _this.getCardMargins(cardEl);
            _this.hiddenArea = _this.carouselEl.children[0].children.length * cardWidth - (visibleArea + lastCardMargin);
            var numOfCardsInView = Math.floor(visibleArea / cardWidth);
            if (_this.props.options.defaultStepper) {
                _this.step = cardWidth * _this.props.options.defaultStepper;
            }
            else {
                _this.step = numOfCardsInView > 1 ? (numOfCardsInView - 1) * cardWidth : numOfCardsInView * cardWidth;
            }
            _this.maxSteps =
                _this.step > _this.hiddenArea ? Math.ceil(_this.hiddenArea / _this.step) : Math.round(_this.hiddenArea / _this.step);
            _this.setState({ carouselX: 0 });
        };
        _this.handleScrollChange = function (event) {
            _this.updateParameters();
            var x;
            if (!_this.carouselEl) {
                return;
            }
            var rangeElement = event.target;
            if (Number(rangeElement.value) > _this.state.carouselX) {
                x = _this.step * (Number(rangeElement.value));
                _this.carouselEl.scrollLeft = x;
                _this.setState({
                    carouselX: ((_this.state.carouselX + 1) > _this.maxSteps) ?
                        _this.maxSteps :
                        _this.state.carouselX + 1,
                });
            }
            else {
                x = Number(rangeElement.value) ===
                    _this.maxSteps ? _this.hiddenArea : _this.step * (Number(rangeElement.value) - 1);
                _this.carouselEl.scrollLeft = x;
                _this.setState({
                    carouselX: ((Number(rangeElement.value) - 1) > _this.maxSteps) ?
                        _this.maxSteps :
                        Number(rangeElement.value) - 1,
                });
            }
        };
        _this.setOptionalClasses();
        _this.state = {
            carouselX: 0,
            containerCls: [styles.carouselContainer, _this.carouselContainer],
            isMinscreensize: _this.isMinscreensize(),
            isMobile: _this.isMobile(),
        };
        _this.onWindowResize = _this.onWindowResize.bind(_this);
        _this.renderCarouselButtons = _this.renderCarouselButtons.bind(_this);
        _this.getCarouselDiv = _this.getCarouselDiv.bind(_this);
        _this.animateCarousel = _this.animateCarousel.bind(_this);
        _this.resetCarouselX = _this.resetCarouselX.bind(_this);
        _this.isMobile = _this.isMobile.bind(_this);
        _this.getCardWidth = _this.getCardWidth.bind(_this);
        _this.getCardMargins = _this.getCardMargins.bind(_this);
        _this.isMinscreensize = _this.isMinscreensize.bind(_this);
        _this.setCardIndex = _this.setCardIndex.bind(_this);
        _this.handleKeyDown = _this.handleKeyDown.bind(_this);
        _this.testIdFirst = (_this.props.testId ? _this.props.testId + '_' : '') + 'spanMsgLeft';
        _this.testIdSecond = (_this.props.testId ? _this.props.testId + '_' : '') + 'spanMsgRight';
        return _this;
    }
    Carousel.prototype.setOptionalClasses = function () {
        if (this.props.options && this.props.options.className) {
            this.carouselClipper = this.props.options.className.carouselClipper;
            this.carouselContainer = this.props.options.className.carouselContainer;
            this.carouselDiv = this.props.options.className.carouselDiv;
            this.carouselNav = this.props.options.className.carouselNav;
            this.carouselPadded = this.props.options.className.carouselPadded;
            this.nextButton = this.props.options.className.nextButton;
            this.prevButton = this.props.options.className.prevButton;
        }
    };
    Carousel.prototype.handleKeyDown = function (e) {
        if (tabIsPressed(e)) {
            e.stopPropagation();
            var el = shiftIsPressed(e) ? (e.target.previousElementSibling ?
                e.target.previousElementSibling : e.target) :
                (e.target.nextElementSibling ? e.target.nextElementSibling : e.target);
            while (el && !el.hasAttribute('data-carousal-card-index')) {
                el = el.parentElement;
            }
            var elIndex = Number(el.getAttribute('data-carousal-card-index') - 1);
            if (!shiftIsPressed(e) && !e.target.nextElementSibling) {
                elIndex = elIndex + 1;
            }
            this.getCardInView(elIndex, e);
        }
    };
    Carousel.prototype.getCardInView = function (index, e) {
        var visibleArea = this.carouselEl.parentElement.offsetWidth;
        var cardsContainer = this.carouselEl.children[0];
        var cardEl = cardsContainer.children[0];
        var cardWidth = this.getCardWidth(cardEl);
        var noOfCards = Math.floor(visibleArea / cardWidth);
        var lastCard = this.carouselEl.children[0].children.length;
        var visibleCarouselEl = this.carouselEl.offsetWidth;
        var i;
        var j;
        if (index === lastCard || index === 1) {
            this.setState({
                carouselX: index === lastCard ? this.maxSteps : 0,
            });
            return;
        }
        if (shiftIsPressed(e) && index === lastCard - 1) {
            this.setState({
                carouselX: this.maxSteps - 1,
            });
            return;
        }
        if (shiftIsPressed(e)) {
            return;
        }
        outerLoop: for (i = 1; i <= noOfCards; i++) {
            var startValue = i === 1 ? 1 : (i - 1) * noOfCards;
            var val = i === 1 ? i * noOfCards : (i * noOfCards) - 1;
            for (j = startValue; j <= val; j++) {
                if (index === j && this.state.carouselX !== (i - 1)) {
                    this.setState({
                        carouselX: (i - 1),
                    });
                    break outerLoop;
                }
            }
        }
    };
    Carousel.prototype.setCardIndex = function () {
        var e_1, _a;
        if (this.carouselEl) {
            var index = 1;
            if (this.carouselEl.querySelectorAll('div.Carousel__children-container> * ')) {
                var LIs = Array.from(this.carouselEl.querySelectorAll('div.Carousel__children-container> *'));
                try {
                    for (var LIs_1 = __values(LIs), LIs_1_1 = LIs_1.next(); !LIs_1_1.done; LIs_1_1 = LIs_1.next()) {
                        var li = LIs_1_1.value;
                        li.setAttribute('data-carousal-card-index', "" + index);
                        index = index + 1;
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (LIs_1_1 && !LIs_1_1.done && (_a = LIs_1.return)) _a.call(LIs_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
        }
    };
    /* istanbul ignore next */
    Carousel.prototype.onWindowResize = function (e) {
        var _this = this;
        this.setState(function () { return ({ isMobile: _this.isMobile() }); });
        this.setState(function () { return ({ isMinscreensize: _this.isMinscreensize() }); });
        this.updateParameters();
        this.resetCarouselX();
        this.initContainerClasses();
    };
    Carousel.prototype.componentDidMount = function () {
        var _this = this;
        this.setState(function () { return ({ isMobile: _this.isMobile() }); });
        this.setState(function () { return ({ isMinscreensize: _this.isMinscreensize() }); });
        window.addEventListener('resize', this.onWindowResize);
        this.updateParameters();
        this.setCardIndex();
        this.resetCarouselX();
        this.initContainerClasses();
    };
    Carousel.prototype.componentWillUnmount = function () {
        window.removeEventListener('resize', this.onWindowResize);
    };
    Carousel.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.props.options && this.props.options.refresh) {
            this.setState(function () { return ({ isMobile: _this.isMobile() }); });
            this.setState(function () { return ({ isMinscreensize: _this.isMinscreensize() }); });
            this.updateParameters();
            this.resetCarouselX();
            this.initContainerClasses();
            this.props.options.refresh = false;
        }
        if (this.counter === 0 && (this.props.options.defaultStep || this.props.options.defaultStepMobile)) {
            setTimeout(function () {
                _this.animateCarousel();
                _this.counter = _this.counter + 1;
            }, 250);
        }
    };
    Carousel.prototype.animateCarousel = function (e) {
        this.updateParameters();
        var x;
        /* istanbul ignore next */
        if (!this.carouselEl) {
            return;
        }
        if (e === undefined) {
            var mobileOffset = this.props.options.mobileOffset;
            var offset = this.props.options.offset;
            if (mobileOffset === null || mobileOffset === undefined) {
                mobileOffset = 0;
            }
            if (offset === null || offset === undefined) {
                offset = 0;
            }
            var defaultStep = this.props.options.defaultStep || 0;
            var defaultStepMobile = this.props.options.defaultStepMobile || 0;
            x = this.state.carouselX + defaultStep === this.maxSteps ? this.hiddenArea :
                this.step * (this.state.carouselX + defaultStep);
            if (this.state.isMobile) {
                x = this.state.carouselX + defaultStepMobile === this.maxSteps ? this.hiddenArea :
                    this.step * (this.state.carouselX + defaultStepMobile);
            }
            var marginF = this.props.options.cardHasShadow ?
                (3 * (this.carouselEl.children[0].children.length)) - 9 : 0;
            if (this.state.isMobile) {
                this.carouselEl.scrollLeft = x + mobileOffset;
            }
            else {
                this.carouselEl.style.transform = "translateX(-" + (x + offset - marginF) + "px)";
            }
            if (this.state.isMobile) {
                this.setState({
                    carouselX: ((this.state.carouselX + defaultStepMobile) >= this.maxSteps) ?
                        this.maxSteps :
                        this.state.carouselX + defaultStepMobile,
                });
            }
            else {
                this.setState({
                    carouselX: ((this.state.carouselX + defaultStep) >= this.maxSteps) ?
                        this.maxSteps :
                        this.state.carouselX + defaultStep,
                });
            }
        }
        else {
            switch (e.currentTarget.value) {
                case 'prev':
                    x = this.step * (this.state.carouselX - 1);
                    this.carouselEl.style.transform = "translateX(-" + x + "px)";
                    this.setState({ carouselX: this.state.carouselX - 1 });
                    break;
                case 'next':
                    x = this.state.carouselX + 1 === this.maxSteps ? this.hiddenArea : this.step * (this.state.carouselX + 1);
                    var marginFix = this.props.options.cardHasShadow ?
                        (3 * (this.carouselEl.children[0].children.length)) - 9 : 0;
                    this.carouselEl.style.transform = "translateX(-" + (x - marginFix) + "px)";
                    this.setState({
                        carouselX: ((this.state.carouselX + 1) > this.maxSteps) ?
                            this.maxSteps :
                            this.state.carouselX + 1,
                    });
                    break;
            }
        }
    };
    Carousel.prototype.renderCarouselButtons = function () {
        var _a, _b;
        var classes = [styles.carouselNavigation, this.carouselNav].join(' ');
        return (React.createElement("div", { className: classes, "aria-label": EnEsLanguageKey_1.getKeyText('carouselButtons') },
            React.createElement("span", { id: this.testIdFirst + '_messageFirst', tabIndex: (this.state.carouselX === 0) ? 0 : -1, role: (this.state.carouselX === 0) ? 'alert' : 'none', "aria-hidden": (this.state.carouselX === 0) ? false : true, "aria-labelledby": this.testIdFirst },
                React.createElement("div", { className: styles.hiddenSpoken, id: this.testIdFirst }, EnEsLanguageKey_1.getKeyText('CarouselDisablePreBtn'))),
            React.createElement("button", __assign({ value: "prev", "aria-label": EnEsLanguageKey_1.getKeyText('CarouselScrollLeft') }, (this.state.carouselX === 0) ?
                (_a = {}, _a['aria-labelledby'] = this.testIdFirst + '_messageFirst', _a) : {}, { onClick: this.animateCarousel, disabled: this.state.carouselX === 0, className: [styles.carouselNavBtn, styles.prev, this.prevButton].join(' ') }),
                React.createElement("i", { className: [icons.attIcon, icons.attIconLeft].join(' ') })),
            React.createElement("button", __assign({ className: [styles.carouselNavBtn, styles.next, this.nextButton].join(' '), value: "next", "aria-label": EnEsLanguageKey_1.getKeyText('CarouselScrollRight') }, (this.state.carouselX === this.maxSteps) ?
                (_b = {}, _b['aria-labelledby'] = this.testIdSecond + '_messageLast', _b) : {}, { role: (this.state.carouselX === this.maxSteps) ? 'none' : 'none', onClick: this.animateCarousel, disabled: this.state.carouselX === 0 ? false : (this.state.carouselX === this.maxSteps) }),
                React.createElement("i", { className: [icons.attIcon, icons.attIconRight].join(' ') })),
            React.createElement("span", { id: this.testIdSecond + '_messageLast', tabIndex: (this.state.carouselX === this.maxSteps) ? 0 : -1, role: (this.state.carouselX === this.maxSteps) ? 'alert' : 'none', "aria-hidden": (this.state.carouselX === this.maxSteps) ? false : true, "aria-labelledby": this.testIdSecond },
                React.createElement("div", { className: styles.hiddenSpoken, id: this.testIdSecond }, EnEsLanguageKey_1.getKeyText('CarouselDisableNxtBtn')))));
    };
    Carousel.prototype.getCarouselDiv = function (div) {
        if (!div) {
            return;
        }
        this.carouselEl = div;
        /* istanbul ignore next */
        this.initContainerClasses();
    };
    Carousel.prototype.setShadowClass = function () {
        return this.props.options.cardHasShadow ? styles.cardHasShadow : '';
    };
    Carousel.prototype.render = function () {
        return (React.createElement("div", { "data-test-id": this.props.testId, className: this.state.containerCls.join(' ') },
            this.props.options.header &&
                React.createElement(CardHeader_1.default, { data: { title: this.props.options.header.title }, options: {
                        background: this.props.options.header.background,
                        className: styles.carouselHeader,
                        isEnabled: this.props.options.header.isEnabled,
                    } }),
            !this.state.isMobile && !this.state.isMinscreensize && this.renderCarouselButtons(),
            React.createElement("div", { className: [styles.padded, this.carouselPadded, this.setShadowClass()].join(' ') },
                React.createElement("div", { className: [styles.carouselClipper, this.carouselClipper].join(' ') },
                    React.createElement("div", { className: [styles.carousel, this.carouselDiv].join(' '), ref: this.getCarouselDiv },
                        React.createElement("div", { className: styles.childrenContainer, onKeyDown: this.handleKeyDown }, this.props.children)))),
            this.state.showScrollBar === true &&
                React.createElement("div", null,
                    React.createElement("input", { type: "range", min: "1", max: Number.isNaN(this.maxSteps) ? 1 : this.maxSteps + 1, className: styles.carouselSlider, value: this.state.carouselX + 1, onChange: this.handleScrollChange, step: (Number.isNaN(this.maxSteps) ? 1 : this.maxSteps + 1) / 10 })),
            this.state.isMinscreensize && this.renderCarouselButtons()));
    };
    Carousel.prototype.isMinscreensize = function () {
        if (window.innerWidth <= 768) {
            return true;
        }
    };
    Carousel.prototype.isMobile = function () {
        return /Android|webOS|iPhone|iPod|iPad|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
    Carousel.prototype.resetCarouselX = function () {
        if (!this.carouselEl) {
            return;
        }
        this.carouselEl.style.transform = 'translateX(0)';
        this.setState({ carouselX: 0 });
    };
    Carousel.prototype.initContainerClasses = function () {
        var cls = [styles.carouselContainer];
        if (this.state.isMobile) {
            this.setState({ containerCls: __spread(cls, [styles.mobile]) });
        }
        else if (this.needCarouselButtons()) {
            this.setState({ containerCls: __spread(cls, [styles.overflowed]) });
        }
        else {
            this.setState({ containerCls: cls });
        }
    };
    Carousel.prototype.getCardWidth = function (cardEl) {
        if (!window) {
            return;
        }
        return cardEl.offsetWidth + this.getCardMargins(cardEl);
    };
    Carousel.prototype.getCardMargins = function (cardEl) {
        if (!window) {
            return;
        }
        var computedStyle = window.getComputedStyle(cardEl);
        return parseInt(computedStyle.marginLeft, 10) + parseInt(computedStyle.marginRight, 10);
    };
    Carousel.prototype.needCarouselButtons = function () {
        if (!this.carouselEl) {
            return;
        }
        if (!React.Children.count(this.props.children)) {
            return;
        }
        var cardRef = this.carouselEl.children[0].children[0];
        var numChilds = this.carouselEl.children[0].children.length;
        var cardWidth = this.getCardWidth(cardRef);
        var cardMargins = parseInt(window.getComputedStyle(cardRef).marginLeft, 10)
            + parseInt(window.getComputedStyle(cardRef).marginRight, 10);
        var maxCardsWidth = numChilds * cardWidth;
        var minAllowedWidth = this.carouselEl.parentElement.parentElement.offsetWidth - this.getCardMargins(cardRef);
        if (minAllowedWidth > 1240 &&
            numChilds >= 4) {
            return true;
        }
        else {
            /* We need to substract right margin of one card. */
            return this.carouselEl.parentElement.parentElement.offsetWidth < ((numChilds * cardWidth) - cardMargins);
        }
    };
    Carousel.defaultProps = {
        options: {
            className: {},
        },
    };
    return Carousel;
}(React.Component));
exports.default = Carousel;
//# sourceMappingURL=Carousel.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/containers/Carousel/Carousel.js
// module id = 1347
// module chunks = 8